/* eslint-disable no-mixed-spaces-and-tabs */
const initialState =
    {
    	activeSpeakerBorderColor : '#ffffff',
    	appToolBarColor          : '#043040',
    	chatBackgroundColor      : '#d1d1d1',
    	iconsColor               : '#D81F1F',
    	iconsColorEnable         : '#2a3f48',
    	pageBackgroundColor      : '#042531',
    	peerShadowColor          : '#377eff',
    	userAvator               : 'themeAvatar6',
    	userBackgroundColor      : '#001822'

    };

const appearance = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'SET_PAGE_BACKGROUND_COLOR':
		{
			const pageBackgroundColor = action.payload.pageBackgroundColor;

			return { ...state, pageBackgroundColor };
		}
		case 'SET_ACTIVE_SPEAKER_COLOR':
		{
			const activeSpeakerBorderColor = action.payload.activeSpeakerBorderColor;

			return { ...state, activeSpeakerBorderColor };
		}
		case 'SET_APP_TOOLBAR_COLOR':
		{
			const appToolBarColor = action.payload.appToolBarColor;

			return { ...state, appToolBarColor };
		}
		case 'SET_CHAT_BACKGROUND_COLOR':
		{
			const chatBackgroundColor = action.payload.chatBackgroundColor;

			return { ...state, chatBackgroundColor };
		}
		case 'SET_ICON_DISABLE_COLOR':
		{
			const iconsColor = action.payload.iconsColor;

			return { ...state, iconsColor };
		}
		case 'SET_ICON_ENABLE_COLOR':
		{
			const iconsColorEnable = action.payload.iconsColorEnable;

			return { ...state, iconsColorEnable };
		}
		case 'SET_PEER_SHADOW_COLOR':
		{
			const peerShadowColor = action.payload.peerShadowColor;

			return { ...state, peerShadowColor };
		}
		case 'SET_USER_BACKGROUND_COLOR':
		{
			const userBackgroundColor = action.payload.userBackgroundColor;

			return { ...state, userBackgroundColor };
		}
		case 'SET_USER_AVATAR_COLOR':
		{
			const userAvator = action.payload.userAvator;

			return { ...state, userAvator };
		}
		default:
			return state;
	}
};

export default appearance;
